module.exports = __webpack_public_path__ + "static/media/red.0353ea33.svg";